<script lang="ts" setup>
const { slug } = useResourceSlug()
import { getNumericDocumentBySlug } from '~/queries/numericDocument'
const { formatToFullDate } = useFullDateFormater()
const { data, pending, error } = await useAsyncData(
  `/numericDocument/${slug}`,
  () =>
    execQuery(() => getNumericDocumentBySlug('workcourse'), {
      slug,
    })
)
const { locale } = useI18n()
const numericDocument = computed(() => {
  if (pending.value || error.value) return {}
  return data.value.data.numericDocumentBySlug
})
</script>
<template>
  <DetailComposer
    :composer="{ firstName: numericDocument?.title }"
    :active-outline-id="'numericDocument'"
    :hide-outline="true"
  >
    <template #heroDescription>
      <div class="flex gap-1">
        <span v-if="numericDocument.authors.length > 0">par</span>
        <div v-for="author in numericDocument.authors">
          <BasicLink
            :key="`${author.firstName}`"
            :to="`/composer/${author.slug}/biography`"
          >
            {{ author.firstName }} {{ author.lastName }}
          </BasicLink>
          <span v-if="numericDocument.publishingStartDate"
            >, le
            {{ formatToFullDate(numericDocument.publishingStartDate) }}</span
          >
        </div>
      </div>
    </template>
    <template #prose="{ classes }">
      <div
        v-if="locale === 'fr'"
        :class="classes"
        class="text-justify"
        v-html="numericDocument?.textFr"
      ></div>
      <div
        v-else
        :class="classes"
        class="text-justify"
        v-html="numericDocument?.textEn"
      ></div>
      <div v-if="numericDocument.copyrights.length > 0">
        ©<span v-for="copyright in numericDocument.copyrights">{{
          copyright.nameC
        }}</span>
      </div>
    </template>
  </DetailComposer>
</template>
